<app-modal bodyClass="p-0" (closing)="onClose()">
  <ng-container ngProjectAs="modal-title">
    <span class="d-inline-flex align-items-center gap-2">
      {{ '$all_notifications$' | translate }}
      @if (unreadNotificationCount() > 0) {
        <span class="notification-count-badge">{{ unreadNotificationCount() }}</span>
      }
    </span>
  </ng-container>

  <ng-container ngProjectAs="modal-body">
    <div class="px-4 py-2 border-bottom d-flex justify-content-end">
      <app-toggle
        class="text-nowrap"
        [label]="'$include_read_notifications$' | translate"
        [(ngModel)]="includeRead"
        (ngModelChange)="onFilterChanged()" />
    </div>

    <p-table
      class="notifications-table mb-0"
      sortField="addedDateTime"
      [sortOrder]="-1"
      [rowHover]="true"
      [paginator]="totalNotifications() > pageSize"
      [rows]="pageSize"
      [value]="notifications()"
      [showCurrentPageReport]="true"
      [class.notifications-table-busy]="loadingNotifications() && !initialLoading()"
      [loading]="initialLoading()"
      [showLoader]="false"
      [lazy]="true"
      [totalRecords]="totalNotifications()"
      (onLazyLoad)="onLazyLoad($event)">
      <ng-template pTemplate="loadingbody">
        @for (loadingRow of loadingRows; track loadingRow) {
          <tr class="notification-skeleton-row">
            <td class="notification-avatar"><p-skeleton shape="circle" size="2.5rem" /></td>
            <td>
              <p-skeleton width="70%" height="1rem" styleClass="mb-2" />
              <p-skeleton width="30%" height="0.75rem" />
            </td>
            <td class="notification-action"></td>
            <td class="notification-action"></td>
          </tr>
        }
      </ng-template>

      <ng-template let-notification pTemplate="body" appTypedTableRow [typedRows]="notifications()">
        <tr class="notification-row cursor-pointer" [class.notification-row-unread]="!notification.readDateTime">
          <td class="notification-avatar" (click)="onOpenClick(notification, false)">
            <app-avatar
              avatarSize="avatar-sm"
              avatarColor="avatar-teal"
              [avatarUrl]="notification.createdByUserId | avatarById | async"
              [avatarInitial]="notification.createdByUserId | userById: 'initials' | async" />
          </td>
          <td (click)="onOpenClick(notification, false)">
            <div class="notification-message" [innerHtml]="notification.message"></div>
            <div class="notification-meta">
              {{ notification.timeToShow }}
              @if (notification.assignmentFriendlyNumber) {
                • {{ '$number_abbreviation_label$' | translate }} {{ notification.assignmentFriendlyNumber }}
              }
            </div>
          </td>
          <td class="notification-action text-center">
            <button
              type="button"
              class="notification-status-toggle"
              tooltipPosition="left"
              [class.unread]="!notification.readDateTime"
              [pTooltip]="(notification.readDateTime ? '$mark_as_Un_read$' : '$mark_as_read$') | translate"
              [attr.aria-label]="(notification.readDateTime ? '$mark_as_Un_read$' : '$mark_as_read$') | translate"
              (click)="onToggleReadClick(notification)">
              @if (notification.readDateTime) {
                <i class="material-icons outlined">drafts</i>
              } @else {
                <i class="material-icons">mail</i>
              }
            </button>
          </td>
          <td class="notification-action text-right more-dropdown">
            <div ngbDropdown placement="bottom-end top-end" class="dropdown dropdown-more user-select-none">
              <button
                aria-haspopup="true"
                ngbDropdownToggle
                class="acting-as-anchor dropdown-toggle no-caret"
                type="button">
                <i class="material-icons">more_vert</i>
              </button>
              <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
                <a ngbDropdownItem class="dropdown-item" (click)="onToggleReadClick(notification)">
                  @if (notification.readDateTime) {
                    <i class="material-icons mi-inline mr-2">mail</i>
                    <span class="font-weight-normal">{{ '$mark_as_Un_read$' | translate }}</span>
                  } @else {
                    <i class="material-icons mi-inline mr-2">drafts</i>
                    <span class="font-weight-normal">{{ '$mark_as_read$' | translate }}</span>
                  }
                </a>
                <a ngbDropdownItem class="dropdown-item" (click)="onOpenClick(notification, true)">
                  <i class="material-icons mi-inline mr-2">launch</i>
                  <span class="font-weight-normal">{{ '$action_open_new_tab$' | translate }}</span>
                </a>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4">
            <div class="card shadow-none bg-transparent">
              <div class="card-body">
                <app-card-empty
                  [message]="(onlyUnread() ? '$no_unread_notifications$' : '$no_notifications_yet$') | translate" />
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <ng-container ngProjectAs="modal-footer">
    <app-button-secondary [text]="'$close$' | translate" (clicked)="onClose()" />
    <app-button-primary
      materialIcon="done_all"
      [outlined]="true"
      [disabled]="unreadNotificationCount() === 0"
      [text]="'$mark_all_read$' | translate"
      (clicked)="onMarkAllReadClick()" />
  </ng-container>
</app-modal>
